<template>
  <ValidationObserver v-slot="{ invalid }">

    <Loader cover v-if="local.isProcessing"/>
    <div class="mb-4">
      <div class="vx-row">
        <div class="vx-col md:w-3/4 sm:w-2/3 w-full">
          <import-excel :onSuccess="onloadDataInTable"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/3 w-full">

          <card-download-template :templateUrl="excelTemplate"></card-download-template>

        </div>
      </div>
    </div>

    <vs-alert :active.sync="showWarningNoCourseOutline"
              class="mb-4"
              closable
              close-icon="icon-x" color="warning" icon="icon-alert-triangle"
              icon-pack="feather">
      {{ $t('exam-upload.course-outline-not-found') }}
    </vs-alert>

    <vs-alert :active.sync="showWarning"
              class="mb-4"
              closable
              close-icon="icon-x" color="warning" icon="icon-alert-triangle"
              icon-pack="feather">
      {{ $t('upload.read-file-fail') }}
    </vs-alert>

    <vs-alert :active.sync="showSuccess"
              class="mb-4"
              closable
              close-icon="icon-x" color="primary" icon="icon-check-circle"
              icon-pack="feather">
      {{ $t('upload.upload-file-success',{allQty:tableData.length,successCount,failCount}) }}
    </vs-alert>

    <vx-card v-if="showTable">
      <vs-table-mod :data="tableData"
                    :max-items="tableConfig.maxItemsPerPage"
                    pagination
                    search>


        <template slot="header-left">

          <div class="vx-col md:w-1/4 sm:w-1/2 w-full mr-2">
            <ValidationProvider :name="$t('vdo-set.subject')" rules="required" v-slot="{ errors }">
              <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('vdo-set.subject')"
                        :options="subjects"
                        :placeholder="$t('vdo-set.search-subject')"
                        class="mb-4 md:mb-0"
                        label="subjectCode"
                        selectOnTab
                        v-model="local.selectedCourseOutline">

                <!--label option-->
                <template #selected-option="{ subject }">
                  {{ subject.code }}
                </template>

                <!--option list-->
                <template v-slot:option="option">
                  {{ option.subject.code }} {{ option.subject.nameLocal }}
                </template>


              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>

          </div>

          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">

            <ValidationProvider :name="$t('exam-upload.question-type')" rules="required" v-slot="{ errors }">
              <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 sm:mb-0"
                        :name="$t('exam-upload.question-type')"
                        :options="examQuestionTypes"
                        :placeholder="$t('exam-upload.question-type')"
                        :clearable="false"
                        label="nameLocal"
                        selectOnTab
                        v-model="local.selectedExamQuestionType">

                <!--label option-->
                <template #selected-option="{ nameLocal }">
                  {{ nameLocal }}
                </template>

                <!--option list-->
                <template v-slot:option="option">
                  {{ option.code }} {{ option.nameLocal }}
                </template>
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>

          </div>

        </template>

        <template slot="header">
          <div class="inline-flex">

            <vx-tooltip :text="$t('general.upload')">
              <vs-button
                :disabled="invalid || showWarningNoCourseOutline"
                @click="onUploadClick"
                class="ml-2" color="primary" icon="icon-upload" icon-pack="feather" radius
                type="filled">
              </vs-button>
            </vx-tooltip>

          </div>
        </template>

        <template slot="thead">
          <vs-th :key="heading" :sort-key="heading" v-for="heading in header">{{ heading }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="col" :key="indexcol + col" v-for="(col, indexcol) in data[indextr]">
              <span
                :class="col === $t('upload.upload-status-code.success') ? 'text-success':col === $t('upload.upload-status-code.fail') ? 'text-danger':''">
                {{ col }}
              </span>
            </vs-td>
          </vs-tr>
        </template>

      </vs-table-mod>
    </vx-card>

  </ValidationObserver>
</template>

<script>
  import {state, loadData} from './data';
  import vSelect from 'vue-select'
  import {tableConfig} from '@/utils/table'
  import {confirmUpload} from '@/utils/dialogs'
  import {showStateNotification, showLocalNotification, notificationType} from '@/utils/notification'
  import ImportExcel from "@/components/excel/ImportExcel.vue"
  import {excelTemplate} from '@/constants/static-files'

  import Exam from '@/store/modules/examination/exam/index';
  import Subject from '@/store/modules/common-data/subject/index';
  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import ExamQuestionType from '@/store/modules/examination/exam-question-type/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.Exam) state.registerModule(`Exam`, Exam);
  if (!state.store.Subject) state.registerModule(`Subject`, Subject);
  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);
  if (!state.store.ExamQuestionType) state.registerModule(`ExamQuestionType`, ExamQuestionType);

  const {
    mapActions: mapExamActions,
  } = createNamespacedHelpers(`Exam`);
  const {
    mapActions: mapSubjectActions,
  } = createNamespacedHelpers(`Subject`);
  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);
  const {
    mapActions: mapExamQuestionTypeActions,
  } = createNamespacedHelpers(`ExamQuestionType`);


  const {mapFields: mapExamFields} = createHelpers({
    getterType: `Exam/getField`,
    mutationType: `Exam/updateField`,
  });
  const {
    mapFields: mapSubjectFields,
  } = createHelpers({
    getterType: `Subject/getField`,
    mutationType: `Subject/updateField`,
  });
  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });
  const {
    mapFields: mapExamQuestionTypeFields,
  } = createHelpers({
    getterType: `ExamQuestionType/getField`,
    mutationType: `ExamQuestionType/updateField`,
  });

  export default {
    components: {
      vSelect,
      ImportExcel,
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
      CardDownloadTemplate: () => import('@/components/shared/card/CardDownloadTemplate.vue'),
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        tableConfig: tableConfig,

        tableData: [],
        header: [],
        sheetName: "",

        showWarning: false,
        showWarningNoCourseOutline: false,
        showSuccess: false,

        headerColumnQty: 9,
        successCount: 0,
        failCount: 0,

        excelTemplate: excelTemplate.EXAM_UPLOAD_TEMPLATE,

      }
    },
    computed: {
      ...mapExamFields(['processing', 'success', 'error']),
      ...mapSubjectFields({subjectProcessing: 'processing'}),
      ...mapCourseOutlineFields({courseOutlineProcessing: 'processing'}),
      ...mapExamQuestionTypeFields({examQuestionTypeProcessing: 'processing'}),
      showTable() {
        return this.tableData.length > 0
      },
      subjects() {
        return this.local.subjects;
      },
      examQuestionTypes() {
        return state.store.ExamQuestionType.examQuestionTypes;
      },
    },
    watch: {
      processing(data) {
        this.local.isProcessing = data;
      },
      success: async function (data) {
        showStateNotification(this.$vs, data);
      },
      error: async function (data) {
        showStateNotification(this.$vs, data);
      },
      subjectProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
      examQuestionTypeProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapExamActions({
        addExamsUpload: 'addExamsUpload',
      }),
      ...mapSubjectActions({
        getSubjectsByCodeOrName: 'getSubjectsByCodeOrName',
      }),
      ...mapCourseOutlineActions({
        getCourseOutlinesByFilter: 'getCourseOutlinesByFilter',
      }),
      ...mapExamQuestionTypeActions({
        getExamQuestionTypes: 'getExamQuestionTypes',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onloadDataInTable({results, header, meta}) {
        //clear warning
        this.showSuccess = false;
        this.showWarning = false;
        //check header length only
        if (!header || header.length !== this.headerColumnQty) {
          showLocalNotification(this.$vs, this.$t('general.error'), this.$t('upload.read-file-fail'), notificationType.ERROR);
          this.showWarning = true;
        } else {//for dynamic header
          // this.header = header;

          //for fix header
          if (this.local.tableHeader.indexOf(this.$t('upload.status')) > 0) {
            this.local.tableHeader.splice(this.local.tableHeader.indexOf(this.$t('upload.status'),1));
          }
          if (this.local.tableHeader.indexOf(this.$t('upload.remark')) > 0) {
            this.local.tableHeader.splice(this.local.tableHeader.indexOf(this.$t('upload.remark'),1));
          }
          //validate data
          const invalidRows = results.filter(item => {
            let count = Object.keys(item).length;
            return count !== this.headerColumnQty;
          });
          if(invalidRows && invalidRows.length > 0){
            showLocalNotification(this.$vs, this.$t('general.error'), this.$t('upload.read-file-fail'), notificationType.ERROR);
            this.showWarning = true;
          }else{
            showLocalNotification(this.$vs, this.$t('general.success'), this.$t('upload.read-file-success'), notificationType.SUCCESS);
            //for fix header
            this.header = this.local.tableHeader;
            this.tableData = results;
            this.sheetName = meta.sheetName;
          }
        }

      },
      async onUploadClick() {
        await confirmUpload(this.$vs, this.saveExamUpload);
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async saveExamUpload() {

        this.showSuccess = false;
        let preparedData = this.prepareDataBeforeUpload(this.tableData);
        let result = await this.addExamsUpload(preparedData);
        if (result) {

          //remove __typeName
          this.tableData.forEach(item => {
            let failRecord = result.resultAddExamsUpload.find(failItem => {
              return parseInt(item[Object.keys(item)[0]]) === failItem.unitSeq
                && item[Object.keys(item)[1]] === failItem.question
            })
            if(failRecord){
              item['status'] = this.$t(failRecord.status);
              item['remark'] = this.$t(failRecord.remark);
            }else{
              item['status'] = this.$t('upload.upload-status-code.success');
              item['remark'] = '';
            }

            delete item['__typeName'];
          })

          this.successCount = result.successCount;
          this.failCount = result.failCount;

          if (this.header.indexOf(this.$t('upload.status')) < 0) {
            this.header.push(this.$t('upload.status'));
          }
          if (this.header.indexOf(this.$t('upload.remark')) < 0) {
            this.header.push(this.$t('upload.remark'));
          }

          this.showSuccess = true;
        }
      },
      prepareDataBeforeUpload(data) {

        return {
          subjectId: this.local.selectedCourseOutline.subject.id,
          teacherId: this.local.selectedCourseOutline.teacher.id,
          examQuestionTypeId: this.local.selectedExamQuestionType.id,
          courseOutlineId: this.local.selectedCourseOutline.id,
          examsUploadInput: data.map(item => {
            return {
              unitSeq: parseInt(item[Object.keys(item)[0]]),
              question: item[Object.keys(item)[1]],
              score: parseInt(item[Object.keys(item)[2]]),
              answer: String(item[Object.keys(item)[3]]),
              choice1: String(item[Object.keys(item)[4]]),
              choice2: String(item[Object.keys(item)[5]]),
              choice3: String(item[Object.keys(item)[6]]),
              choice4: String(item[Object.keys(item)[7]]),
              isRandom: item[Object.keys(item)[8]] === 1,
            }
          })
        }

      },
      async initData() {
        if(!state.store.ExamQuestionType.examQuestionTypes || state.store.ExamQuestionType.examQuestionTypes.length === 0){
          await this.getExamQuestionTypes();

          if(state.store.ExamQuestionType.examQuestionTypes && state.store.ExamQuestionType.examQuestionTypes.length > 0){
            this.local.selectedExamQuestionType = state.store.ExamQuestionType.examQuestionTypes[0];
          }
        }

        let payload = {
          courseOutlineFilterInput: {
            currentTeacher: true
          }
        };

        this.local.subjects = await this.getCourseOutlinesByFilter(payload);

      },
      async loadData() {
        let func = {
          getCourseOutlinesByFilterForTable: this.getCourseOutlinesByFilterForTable
        }
        await loadData(func);
        if(!this.local.courseOutline){
          this.showWarningNoCourseOutline = true;
        }else{
          this.showWarningNoCourseOutline = false;
        }
      },
    },
    async mounted() {
      await this.initData();
    }
  }
</script>

<style>
</style>
